import { createContext, useContext, useState } from "react";
import es from "../utils/es";
import en from "../utils/en";

const LanguageContext = createContext();

const LANG_MAP = { es, en };

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(
    localStorage.getItem("lang") || "es"
  );

  const t = LANG_MAP[language];

  const switchLanguage = () => {
    setLanguage((prev) => {
      const next = prev === "es" ? "en" : "es";
      localStorage.setItem("lang", next);
      return next;
    });
  };

  return (
    <LanguageContext.Provider value={{ language, t, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
